// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"1969":"72c9b1c96f2906548628","2995":"7533d71c7440b072dfc9"}[chunkId] + ".js";
};